import { render, staticRenderFns } from "./CdbCustomerEdit.vue?vue&type=template&id=773ec024&scoped=true&"
import script from "./CdbCustomerEdit.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerEdit.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerEdit.vue?vue&type=style&index=0&id=773ec024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ec024",
  null
  
)

export default component.exports